import React from 'react';
import { CircularProgress } from '@mui/material';
import './LoadingState.css';

/**
 * LoadingState — Standardized loading indicator
 * 
 * @param {'spinner'|'skeleton'} variant
 * @param {string} message - Optional loading message
 * @param {'sm'|'md'|'lg'} size
 * @param {boolean} fullPage - Center in full viewport
 */
const LoadingState = ({
  variant = 'spinner',
  message = 'Loading...',
  size = 'md',
  fullPage = false,
  className = '',
}) => {
  const sizes = { sm: 24, md: 36, lg: 48 };

  if (variant === 'skeleton') {
    return (
      <div className={`ck-loading-skeleton ${className}`}>
        <div className="ck-skeleton-line ck-skeleton-line--short" />
        <div className="ck-skeleton-line ck-skeleton-line--full" />
        <div className="ck-skeleton-line ck-skeleton-line--full" />
        <div className="ck-skeleton-line ck-skeleton-line--medium" />
      </div>
    );
  }

  return (
    <div className={`ck-loading ${fullPage ? 'ck-loading--full-page' : ''} ${className}`}>
      <div className="ck-loading-inner">
        <CircularProgress style={{ color: 'var(--ck-green)' }} size={sizes[size]} />
        {message && <span className="ck-loading-message">{message}</span>}
      </div>
    </div>
  );
};

export default LoadingState;
